module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Thank you for buying this ebook, published by NYU Press.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("Sign up for our e-newsletters to receive information about forthcoming books, special discounts, and more!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://visitor.r20.constantcontact.com/manage/optin/ea?v=001KZi1d-co_IgG73nIY9WRDzh9DJJyEE2O6VvzPleP3DWuoH1L7zNGEwJ2ebEmTTkZeUb8IYeZv2Ta39CFZxqnA8WlTuerSkd0AgpeHhm1RWSGXrC7_LnQ-mZo5QgT3m6z",
      "target": "_blank"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "button"
  }, [_vm._v("Sign Up!")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("About NYU Press")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("A publisher of original scholarship since its founding in 1916, New York University Press Produces more than 100 new books each year, with a backlist of 3,000 titles in print. Working across the humanities and social sciences, NYU Press has award-winning lists in sociology, law, cultural and American studies, religion, American history, anthropology, politics, criminology, media and communication, literary studies, and psychology.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f6fd84b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abtnyup_press.vue
// module id = 57
// module chunks = 0